import React from "react";
import BaseComponentInternas from "../../Components/BaseComponentInternas";
import ChangePasswordComponent from "../../Components/ChangePassword";
import HeaderStroke from "../../Components/HeaderStroke";
const ChangeEmail = () => {
  return (
    <BaseComponentInternas>
      <HeaderStroke name="Alterar senha" msgDadosCadastrais={false} />{" "}
      <ChangePasswordComponent />
    </BaseComponentInternas>
  );
};

export default ChangeEmail;
